// src/utils/authHelpers.js
import { showGlobalAuthModal } from "../hooks/useAuthModal";

export const getUserToken = () => localStorage.getItem("authToken");
export const getGuestToken = () => localStorage.getItem("guestToken");

export const emitAuthChanged = () => {
  window.dispatchEvent(new Event("auth:changed"));
};

// ✅ set guest token (same-tab update)
export const setGuestToken = (token) => {
  localStorage.setItem("guestToken", token);
  emitAuthChanged();
};

export const setUserToken = (token) => {
  localStorage.setItem("authToken", token);
  emitAuthChanged();
};

export const getAuthMode = () => {
  const user = getUserToken();
  const guest = getGuestToken();
  if (user) return "user";
  if (guest) return "guest";
  return "none";
};

export const isUser = () => getAuthMode() === "user";
export const isGuest = () => getAuthMode() === "guest";
export const isGuestOrUser = () => {
  const m = getAuthMode();
  return m === "user" || m === "guest";
};

// user-only
export const requireUserAuth = (message = "Please login to continue") => {
  if (!getUserToken()) {
    showGlobalAuthModal(message);
    return false;
  }
  return true;
};

// guest OR user
export const requireGuestOrUser = (
  message = "Please login or continue as guest to continue"
) => {
  if (!isGuestOrUser()) {
    showGlobalAuthModal(message);
    return false;
  }
  return true;
};

export const clearGuest = () => {
  localStorage.removeItem("guestToken");
  emitAuthChanged();
};

export const clearUser = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("userData");
  emitAuthChanged();
};